import { types } from 'mobx-state-tree';

export const Distributor = types.model({
  id: types.identifierNumber,
  name: types.string,
  establishment_id: types.number,
  archived: types.boolean,
  created_at: types.string,
  updated_at: types.string,
  created_by: types.number,
  _establishments_name: types.string,
  _users_display_name_created_by: types.string,
  _users_display_name_updated_by: types.string,
});

export const DistributorSchedules = types.model({
  id: types.identifierNumber,
  delivery_frequency_days: types.number,
  distributor_id: types.number,
  order_day_of_week: types.string,
  _distributors_name: types.string,
});
